(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lehmmeister-home-hero-editorial"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lm-home-editorial-hero]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-lm-editorial-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-lm-editorial-dot]'));

    if (slides.length < 2) return;

    const interval = Math.max(4000, Number(root.dataset.interval) || 6500);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer = 0;

    const show = (index) => {
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = 0;
    };

    const start = () => {
      if (reducedMotion) return;
      stop();
      timer = window.setInterval(() => show(current + 1), interval);
    };

    root.querySelector('[data-lm-editorial-prev]')?.addEventListener('click', () => {
      show(current - 1);
      start();
    });

    root.querySelector('[data-lm-editorial-next]')?.addEventListener('click', () => {
      show(current + 1);
      start();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.index) || 0);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) start();
    });

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lehmmeister-home-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lm-home-hero]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-lm-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-lm-hero-dot]'));

    if (slides.length < 2) return;

    const interval = Math.max(4000, Number(root.dataset.interval) || 6500);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer = 0;

    const show = (index) => {
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = 0;
    };

    const start = () => {
      if (reducedMotion) return;
      stop();
      timer = window.setInterval(() => show(current + 1), interval);
    };

    root.querySelector('[data-lm-hero-prev]')?.addEventListener('click', () => {
      show(current - 1);
      start();
    });

    root.querySelector('[data-lm-hero-next]')?.addEventListener('click', () => {
      show(current + 1);
      start();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.index) || 0);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) start();
    });

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
